import { Config, httpGet } from "../../services/api";
import { formatPlans } from "../utils/formatFormField";

export const sdkGetInstallmentPlans = async ({
  first6Digits,
  amount,
  currency,
  publicApiKey,
  lang,
}: {
  first6Digits?: string;
  amount: string;
  currency: string;
  publicApiKey: string;
  lang: string;
}) => {
  const url = new URL(
    `${import.meta.env.VITE_API_BASE}/api/${
      Config.apiVersion
    }/payments/installment_plans/`
  );
  url.searchParams.append("lang", lang);
  first6Digits && url.searchParams.append("first_six_digits", first6Digits);
  url.searchParams.append("currency", currency);
  url.searchParams.append("amount", amount.toString());

  const response = await httpGet<InstallmentPlansApiResponse>(
    url.toString(),
    true,
    undefined,
    {
      "x-public-key": publicApiKey,
    }
  );

  return formatPlans({
    plans: response.data.plans,
    currency,
    providerRelatedFields: response.data.provider_related_fields,
  });
};
